import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    workshopDetails: null,
  },
  reducers: {
    setWorkshopDetails: (state, action) => {
      state.workshopDetails = action.payload;
    },
    clearWorkshopDetails: (state) => {
      state.workshopDetails = null;
    },
  },
});

export const { setWorkshopDetails, clearWorkshopDetails } = userSlice.actions;

export const selectWorkshopDetails = (state) => state.user.workshopDetails;

export default userSlice.reducer;